// @ts-nocheck

// link-bot shadow DOM 结构：
//   .ibot-service (flex 容器)
//     [iframe 聊天面板 - n.value=true 时渲染]  ← 与按钮并列
//     div > .ibot-icon-box onClick:b           ← 浮窗按钮
//
// 策略：用 opacity:0 + pointer-events:none 隐藏按钮
// 好处：元素仍在 DOM 中，programmatic click 不受 display:none 限制

let _iconBox: HTMLElement | null = null;

const hideBtnStyle = (el: HTMLElement) => {
  el.style.setProperty('opacity', '0', 'important');
  el.style.setProperty('pointer-events', 'none', 'important');
  // 兜底：也处理父容器的 visibility，防止 SDK CSS 覆盖
  if (el.parentElement) {
    el.parentElement.style.setProperty('opacity', '0', 'important');
    el.parentElement.style.setProperty('pointer-events', 'none', 'important');
  }
};

/** 轮询等待 .ibot-icon-box 出现，用 opacity 隐藏它 */
const waitAndHide = () => {
  const el = document.querySelector('link-bot') as any;
  const shadow = el?.shadowRoot as ShadowRoot | null;
  const iconBox = shadow?.querySelector<HTMLElement>('.ibot-icon-box');
  if (iconBox) {
    _iconBox = iconBox;
    hideBtnStyle(iconBox);
  } else {
    setTimeout(waitAndHide, 300);
  }
};

// linkai客服初始化
export const opsigenesInit = () => {
  const x = document.createElement('script');
  x.defer = true;
  x.dataset.name = 'link-bot';
  x.dataset.clientId = '01650cd4-33c3-443e-ae4c-a960af441482';
  x.src = 'https://link-ai.tech/link-bot.min.js';
  document.body.appendChild(x);
  x.onload = () => setTimeout(waitAndHide, 800);
};

// 打开 linkai 客服对话框，供自定义按钮调用
export const openLinkAiChat = () => {
  // 每次都重新查询，避免 Vue 重新渲染后引用失效
  const el = document.querySelector('link-bot') as any;
  const shadow = el?.shadowRoot as ShadowRoot | null;
  // click 监听器挂在 .ibot-icon 上（不是 .ibot-icon-box）
  const icon = shadow?.querySelector<HTMLElement>('.ibot-icon');

  if (!icon) return;

  // opacity:0 + pointer-events:none 不阻止 programmatic click
  // 直接 click，不需要先 show
  icon.click();
};
